export const enum SuccessfulWithdrawStatus {
	FAILED = 'failed',
	PROCESSED = 'processed',
	PROCESSING = 'processing'
}
